import script from "./SafieButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SafieButton.vue?vue&type=script&setup=true&lang=ts"

import "./SafieButton.vue?vue&type=style&index=0&id=2cb115af&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb115af"]])

export default __exports__